import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { AddEdit } from './AddEdit';

import { List } from "./List";

function Compras({ match }) {
    const { path } = match;

    return (
        <Switch>

            <Route exact path={`${path}/:compras`} component={List} />
            <Route path={`${path}/:compras/add`} component={AddEdit} />
            <Route path={`${path}/:compras/edit/:id`} component={AddEdit} />         
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    );
}


export { Compras };
